export default __webpack_public_path__ + "static/media/donuts-no-4.d2747f51.mid";